export const TRACKING_SITE = 'BMW Thorne';

export const TRACKING_VIN = 'WBA5R1C09NCJ12345';

export const TRACKING_MAP = '/images/thorne-map.png';

export const TRACKING_MAP_W = 900;

export const TRACKING_MAP_H = 1014;

export interface TrackingStop {
  zone: string;
  time: string;
  done: boolean;
  x: number;
  y: number;
}

// x/y are pixel coordinates on the Thorne site-plan image (900 x 1014).
export const TRACKING_ROUTE: TrackingStop[] = [
  { zone: 'Gate in', time: '06:42', done: true, x: 556, y: 60 },
  { zone: 'PDI Buffer', time: '07:05', done: true, x: 470, y: 258 },
  { zone: 'PDI Feeder', time: '08:18', done: true, x: 398, y: 430 },
  { zone: 'Main Storage Area', time: '09:40', done: true, x: 300, y: 628 },
  { zone: 'FPR Bay', time: 'pending', done: false, x: 252, y: 720 },
];
